import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

const Dialog = (props) => (
  <Modal
    visible={props.isOpen}
    title={props.title}
    footer={props.actions}
    onCancel={props.onCancel}
    width={props.width}
    closable={props.closeable}
    maskClosable={props.maskClosable}
  >
    {props.children}
  </Modal>
);

Dialog.propTypes = {
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  children: PropTypes.node.isRequired,
  actions: PropTypes.arrayOf(PropTypes.node),
  isOpen: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  closeable: PropTypes.bool,
  maskClosable: PropTypes.bool,
};

Dialog.defaultProps = {
  isOpen: false,
  onCancel: null,
  width: 600,
  closeable: true,
  maskClosable: true,
};

export default Dialog;
